

import Vue from 'vue';
import Component from "vue-class-component";
import {namespace} from "vuex-class";

import {IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {ILocker} from "@/model/Locker/lockerInterfaces";

const lockerModule = namespace("lockerModule");

  @Component({
    name: 'LMCredentialsDialog',
  })
  export default class LMCredentialsDialog extends Vue {

    @Prop()
    protected locker!: ILocker;

    @lockerModule.Getter('credentials')
    private credentials!: any;

    protected showing: boolean = false;
    protected loading: boolean = false;
    protected subscribes: IOnOffHandlers = {};
    private enteredMachineNumber: string = ''; // user should enter same number as machineNumber

    private get enteredMachineNumberIsValid() {
      return this.locker.machine_number && this.enteredMachineNumber == this.locker.machine_number;
    }

    created() {
      this.subscribes = this.$ons({
        // NOTE not managing login OK/KO here as it would cause more problems than solve
        'l-m-credentials-dialog.show': this.onShow,
        'backend.call.OK.pushConfiguration': this.onOK,
        'backend.call.KO.pushConfiguration': this.onKO,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    private onShow(locker: ILocker) {
      this.locker = locker;
      this.showing = true;
      this.$store.dispatch('lockerModule/fetchCredentials', this.locker.id);
    }

    private onPushConfiguration() {
      // guard if enter pressed but button is disabled indeed
      if (!this.enteredMachineNumberIsValid) {
        return;
      }
      this.loading = true;
      this.$store.dispatch('lockerModule/pushConfiguration', {
        lockerId: this.locker.id,
        machine_number: this.enteredMachineNumber,
      });
    }

    private onOK() {
      this.loading = false;
      this.$uiBus.emit('success', 'OK');
      this.showing = false;
    }

    private onKO() {
      this.loading = false;
      this.$uiBus.emit('alert', 'KO');
    }

  }

